import http from "../http-common";

class BannerService {
    createBanner(data) {
      return http.post("banner/create", data);
    }
    getBanners() {
        return http.get("banner/list");
    }
    deleteBanner(data) {
      return http.delete("banner/delete", { params: data });
  }
}

export default new BannerService();